<template>
	<v-sheet>
		<v-row>
			<v-col>
				<v-select
					v-model="sendGridMessageId"
					:items="filteredSendGridMessages"
					label="Sendgrid Template" item-value="value" item-text="text"
				></v-select>
			</v-col>
			<v-col>
				Contact Channels<br/>
				<v-checkbox hide-details v-model="channels" value="email" label="Email"></v-checkbox>
				<v-checkbox hide-details v-model="channels" value="sms" label="SMS"></v-checkbox>
			</v-col>
		</v-row>
		<v-row v-if="sendGridMessage">
			<v-col v-if="sendGridMessage.requiresProject && !sendGridMessage.requiresAppointment" >
				<v-select label="Project" :items="projectList" item-value="id" item-text="internalName" v-model="project"></v-select>
			</v-col>
		</v-row>
	</v-sheet>
</template>

<script>

/*
This component is meant to be temporary 
Ultimately we would want to handle template building including content + merge fields in this system and only handle the sending using sendgrid
*/

	import Vuex from "vuex";
	export default {
		name: "ExternalTemplateMessage",
		props: {
			"recipients": {type: Array, default: () => [] }, 
			"otherParams": {type: Object, default: () => { return { project: false, appointments: false } } } 
		},
		computed: {
			...Vuex.mapState({
				projects: state => state[state.auth.view].projects.filter( p => p.active ),
			}),
			sendGridMessage( ){
				var id = this.sendGridMessageId;
				if(!id){ return false }
				return this.sendGridMessages.find(  s => s.value == id )
			},
			filteredSendGridMessages() {
				if( !this.otherParams.appointments ){
					return this.sendGridMessages.filter( a => !a.requiresAppointment )
				}
				return this.sendGridMessages;
			},
			projectList(){
				if( !this.projects.length){ return [] }
				return [...this.projects].reverse();
			},
			valid(){
				if( !this.sendGridMessage ){
					return false;
				}
				if( this.sendGridMessage.requiresProject && !this.project ){
					return false;
				} 
				return true;
			}, 
			contactEvents() {
				const self = this;
				if( !self.sendGridMessage ){ return []; }
				let events = [];
				self.channels.forEach( c => {							
					if( !self.sendGridMessage.requiresAppointment ){
						self.recipients.forEach( (r) => {
							var event = {
								recipient: r, 
								channel: c,
								sendGridMessage: self.sendGridMessageId
							}
							if( self.sendGridMessage.requiresProject ){
								event.project = self.project;
							}
							events.push( event )
						})
					}
					else{
						self.otherParams.appointments.forEach( (a) => {
							var event = {
								recipient: a.recipient,
								project: a.project, 
								appointment: a.appointment, 
								channel: c,
								sendGridMessage: self.sendGridMessageId
							}		
							events.push( event )					
						})
					}
				})
				return events
			}
		},
		data: () => {
			return {
				project: false,
				sendGridMessageId: "", 
				channels: [],
				sendGridMessages: [
					{ 
						text: 'Registration',
						value: 'd-a353fe6413f74ab4bf5107f28bb1c6b0',
						requiresProject: false,
						requiresAppointment: false,
						defaultChannels: ["email", "sms"]
					},
					{ 
						text: 'Invite',
						value: 'd-d17de2bb39554b089b597e477e14b47e' , 
						requiresProject: true,
						requiresAppointment: false,
						defaultChannels: ["email", "sms"]
					},
					{ 
						text: 'Scheduling',
						value: 'd-1073b8fd00df49e5be56c7597ac76377', 
						requiresProject: true,
						requiresAppointment: false,
						defaultChannels: ["email", "sms"] 
					},
					{ 
						text: 'Confirmation',
						value: 'd-6da7ac350c6c415787cdc0081b21d0d9', 
						requiresProject: true,
						requiresAppointment: true,
						defaultChannels: ["email", "sms"] 
					},
					{ 
						text: 'Reminder',
						value: 'd-1488b6a3d20b408e94d75c8c6c89b01d', 
						requiresProject: true,
						requiresAppointment: true,
						defaultChannels: [ "sms"] 
					},
					{ 
						text: 'Reward Link',
						value: 'd-bb1600877f54444dabe307e7742002f6', 
						requiresProject: true,
						requiresAppointment: false,
						defaultChannels: ["email"]
					} 
				]
			}
		},
		watch: {
			sendGridMessageId: {
				immediate: true,
				handler(){
					if( this.sendGridMessage ){
						if( !this.projects.length && this.sendGridMessage.requiresProject ){
							this.$store.dispatch("fetch", "projects" )
						}
						if( !this.channels.length  ){
							this.channels = this.sendGridMessage.defaultChannels;
						}
					}
				}
			},
			valid(valid){
				this.$emit("validate", valid)
			}, 
			contactEvents(events){
				this.$emit( "batch", events );
			}
		},
		created(){
			if( this.otherParams.project ){
				this.project = this.otherParams.project;
			}
		}
	}
</script>